import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ImageuploadComponent } from 'src/app/imageupload/imageupload.component';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { ToastService } from 'src/app/_services/toastservice';
import { NgbdDatepickerRangePopup } from 'src/app/datepicker-range/datepicker-range-popup';
import { SettingService } from 'src/app/_services/settings.service';
import * as $ from 'jquery';
import 'bootstrap-colorpicker';
import { BgFeatureduploadComponent } from '../../../themeImages/bgfeaturedupload/bgfeaturedupload.component';
import { BgNewarrivaluploadComponent } from '../../../themeImages/bgnewarrivalupload/bgnewarrivalupload.component';
import { BgNewsletteruploadComponent } from '../../../themeImages/bgnewsletterupload/bgnewsletterupload.component';
import { BgPopularuploadComponent } from '../../../themeImages/bgpopularupload/bgpopularupload.component';
import { BgTestimonialuploadComponent } from '../../../themeImages/bgtestimonialupload/bgtestimonialupload.component';
import { BgWorkflowuploadComponent } from '../../../themeImages/bgworkflowupload/bgworkflowupload.component';
import { logouploadComponent } from '../../../themeImages/logoupload/logoupload.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-dynamiccss',
  templateUrl: './dynamiccss.component.html'
})
export class DynamicCssComponent implements OnInit {

  themes = [{ themeName: 'Default' }, { themeName: 'MotherDay' }, { themeName: 'ValentineDay' }];
  selectedTheme: string = 'Default';
  themeSettings: any = {};

  submitted = false;
  dynamiccssForm: FormGroup;
  loading = false;
  loadingDynamicCss = false;
  ButtonText = "Save";
  constructor(private http: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router,
    public ts: ToastService,
    private service: SettingService
  ) {
    this.createForm();
  }

  onThemeChange(event: any) {
    debugger
    this.selectedTheme = event.target.value;  // Ensure value updates
    console.log("Selected Theme:", this.selectedTheme); // Debugging
    this.loadThemeSettings();
  }

  ngOnInit(): void {
    //this.setSelectedDynamicCss();
    this.loadThemeSettings();
  }

  @ViewChild(BgFeatureduploadComponent, { static: true }) featuredimg;
  @ViewChild(BgNewarrivaluploadComponent, { static: true }) newarrivalimg;
  @ViewChild(BgNewsletteruploadComponent, { static: true }) newsletterimg;
  @ViewChild(BgPopularuploadComponent, { static: true }) popularprdimg;
  @ViewChild(BgTestimonialuploadComponent, { static: true }) testimonialimg;
  @ViewChild(BgWorkflowuploadComponent, { static: true }) workflowimg;
  @ViewChild(logouploadComponent, { static: true }) logoimg;

  get f() { return this.dynamiccssForm.controls; }

  private createForm() {
    this.dynamiccssForm = this.formBuilder.group({
      headerToparea: ['#c06dff'],
      bgWorkflow: [''],
      logo: [''],
      themeName: [''],
      bgFeaturedProduct: [''],
      bgPopularProduct: [''],
      bgNewArrivals: [''],
      bgTestimonials: [''],
      bgNewsletter: [''],
      addButton: ['#c06dff'],
      dynamiccssID: 0,
      isActive:[false]
    });
  }

  private editForm(obj) {
    debugger
    this.f.dynamiccssID.setValue(obj.dynamicCssID);
    this.f.themeName.setValue(this.selectedTheme);
    this.f.headerToparea.setValue(obj.headerToparea);
    this.f.logo.setValue(obj.logo);
    this.f.bgWorkflow.setValue(obj.bgWorkflow);
    this.f.bgFeaturedProduct.setValue(obj.bgFeaturedProduct);
    this.f.bgPopularProduct.setValue(obj.bgPopularProduct);
    this.f.bgNewArrivals.setValue(obj.bgNewArrivals);
    this.f.bgTestimonials.setValue(obj.bgTestimonials);
    this.f.bgNewsletter.setValue(obj.bgNewsletter);
    this.f.addButton.setValue(obj.addButton);
    this.f.isActive.setValue(obj.isActive == 1 ? true : false);
    this.featuredimg.imageUrl = obj.bgFeaturedProduct;
    this.newarrivalimg.imageUrl = obj.bgNewArrivals;
    this.newsletterimg.imageUrl = obj.bgNewsletter;
    this.popularprdimg.imageUrl = obj.bgPopularProduct;
    this.testimonialimg.imageUrl = obj.bgTestimonials;
    this.workflowimg.imageUrl = obj.bgWorkflow;
    this.logoimg.imageUrl = obj.logo;
    
  }

  setSelectedDynamicCss() {
    this.service.getCssById(0).subscribe(res => {
      this.editForm(res);
      this.loadingDynamicCss = false;
    });
  }

  loadThemeSettings() {
    debugger
    this.http.get(`/api/settings/getThemeSettings?ThemeName=${this.selectedTheme}`)
      .subscribe((data: any) => {
        this.themeSettings = data || {};
        this.editForm(data);
      });
  }

  onSubmit() {
    debugger
    this.dynamiccssForm.markAllAsTouched();
    this.submitted = true;
    if (this.dynamiccssForm.invalid) { return; }
    this.loading = true;
    this.f.logo.setValue(this.logoimg.imageUrl);
    this.f.bgWorkflow.setValue(this.workflowimg.imageUrl);
    this.f.bgFeaturedProduct.setValue(this.featuredimg.imageUrl);
    this.f.bgPopularProduct.setValue(this.popularprdimg.imageUrl);
    this.f.bgNewArrivals.setValue(this.newarrivalimg.imageUrl);
    this.f.bgTestimonials.setValue(this.testimonialimg.imageUrl);
    this.f.bgNewsletter.setValue(this.newsletterimg.imageUrl);
    this.f.isActive.setValue(this.f.isActive.value == true ? 1 : 0);
    this.service.updateCss(this.dynamiccssForm.value).subscribe(data => {
      this.loading = false;
      if (data != 0) {
        this.ts.showSuccess("Success", "Record updated successfully.")
        this.router.navigate(['/admin/dynamiccss']);
      }
    }, error => {
      this.ts.showError("Error", "Failed to update record.")
      this.loading = false;
    });
  }
}
